module.exports = __webpack_public_path__ + "img/imgbindgay.f64f0e4d.png";